import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sat Sep 09 2018
 * @author LZe
 */
import * as React from 'react';
import { InputValidated } from '../../../../inputs/Input';
import CellEditor from './CellEditor';

var TextEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(TextEditor, _CellEditor);

  function TextEditor(props) {
    var _this;

    _classCallCheck(this, TextEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextEditor).call(this, props));

    _this.onChange = function (event) {
      _this.updateValue(event.target.value);
    };

    _this.onFocus = function (event) {
      return event.target.select();
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(InputValidated, {
        validationError: _this.state.validationError,
        type: "text",
        value: _this.state.value,
        onChange: _this.onChange,
        className: "ag-cell-editor",
        tiny: true,
        onFocus: _this.onFocus
      }));
    };

    return _this;
  }

  _createClass(TextEditor, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.charPress) {
        this.updateValue(this.props.charPress);
      }
    }
  }]);

  return TextEditor;
}(CellEditor);

export { TextEditor as default };